// Home affairs

const Homedata=[

        {
            id : "1",
            schemeName: "Crime And Criminal Tracking Network and Systems",
            discription:"It is a Mission Mode Project (MMP) under the National e-Governance Plan of Govt. of India. It is aimed to create a comprehensive and integrated system for enhancing the efficiency and effectiveness of Police.",
            launchDate: "2009 year",
            AnualFund: "12745"
    
        },
       {id : "2",
        schemeName: "Bharat ke Veer ",
        discription:"It is an online portal in which anyone can make fiscal contributions to the families of martyrs of the CAPF",
        launchDate: " 9 April",
        AnualFund: "12375"},
       
    
        {id : "3",
        schemeName: "Operation Muskan/Operation Smile",
        discription:"The main aim of the programme is to prevent child trafficking and rescue children from persons who try to engage them in begging, sexual trade and other antisocial activities.",
        launchDate: "July 2015",
        AnualFund: "123675"},
]
export default Homedata;